export default {}



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/uploader/getters.js